<div class="org-2fa-page">
    <div *ngIf="isLoadingStatus" class="org-2fa-loading">{{'aumico_mfa_loading' | i18next}}</div>

    <!-- Disabled state: illustration + button -->
    <div class="org-2fa-promo" *ngIf="!isLoadingStatus && !mfaEnabled">
        <div class="org-2fa-promo-illustration">
            <div class="org-2fa-device-frame">
                <div class="org-2fa-device-screen">
                    <div class="org-2fa-screen-header">
                        <span class="org-2fa-back-arrow">&#8592;</span>
                        <div>
                            <div class="org-2fa-screen-title">{{'aumico_mfa_org_toggle_title' | i18next}}</div>
                            <div class="org-2fa-screen-subtitle">{{'aumico_mfa_org_toggle_description_detail' | i18next}}</div>
                        </div>
                    </div>
                    <div class="org-2fa-code-inputs">
                        <span class="org-2fa-code-box"></span>
                        <span class="org-2fa-code-box"></span>
                        <span class="org-2fa-code-box"></span>
                        <span class="org-2fa-code-box"></span>
                        <span class="org-2fa-code-box"></span>
                        <span class="org-2fa-code-box"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="org-2fa-promo-content">
            <h2 class="org-2fa-promo-title">{{'aumico_mfa_org_toggle_title' | i18next}}</h2>
            <p class="org-2fa-promo-desc">{{'aumico_mfa_org_toggle_description' | i18next}}</p>
            <p class="org-2fa-promo-desc">{{'aumico_mfa_org_toggle_description_detail' | i18next}}</p>
            <!-- REV-22124: enabling revokes every login of the org, the admin's own included -->
            <ham-button
                [disabled]="isLoadingToggle"
                [hamTooltip]="'aumico_mfa_org_enforce_button_tooltip' | i18next"
                [multiline]="true"
                tooltipMaxWidth="400px"
                (buttonClick)="enableMfa()"
            >
                {{'aumico_mfa_org_enforce_button' | i18next}}
            </ham-button>
        </div>
    </div>

    <!-- Enabled state: toggle row + users table -->
    <ng-container *ngIf="!isLoadingStatus && mfaEnabled">
        <div class="org-2fa-toggle-section">
            <div class="org-2fa-toggle-header">
                <!-- REV-22124: disabling resets every user's 2FA setup -->
                <ham-toggle
                    [checked]="true"
                    [disabled]="isLoadingToggle"
                    [hamTooltip]="'aumico_mfa_org_disable_toggle_tooltip' | i18next"
                    (changed)="onMfaToggleChange($event)"
                ></ham-toggle>
                <div class="org-2fa-toggle-info">
                    <span class="org-2fa-toggle-title">{{'aumico_mfa_org_toggle_title' | i18next}}</span>
                    <span class="org-2fa-toggle-desc">{{'aumico_mfa_org_toggle_description' | i18next}}</span>
                </div>
            </div>
        </div>

        <div class="org-2fa-section">
            <div *ngIf="isLoadingUsers" class="org-2fa-loading">{{'aumico_mfa_loading' | i18next}}</div>

            <ham-table
                *ngIf="!isLoadingUsers"
                [dataSource]="users"
                [pageSize]="50"
                [columnClasses]="['', '', '', '', 'actions-col']"
            >
                <!-- ── Header cells ─────────────────────────────────────────── -->
                <ng-template hamHeaderCell>
                    <div class="header-sort-col" (click)="sortBy(MfaSortingProperties.NAME)">
                        {{'aumico_mfa_org_users_col_name' | i18next}}
                        <span
                            *ngIf="activeSortBy !== MfaSortingProperties.NAME"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.NAME && activeSortOrder === SortDirection.ASC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.NAME && activeSortOrder === SortDirection.DESC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.NAME)"
                        ></span>
                    </div>
                </ng-template>

                <ng-template hamHeaderCell>
                    <div class="header-sort-col" (click)="sortBy(MfaSortingProperties.EMAIL)">
                        {{'aumico_mfa_org_users_col_email' | i18next}}
                        <span
                            *ngIf="activeSortBy !== MfaSortingProperties.EMAIL"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.EMAIL)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.EMAIL && activeSortOrder === SortDirection.ASC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.EMAIL)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.EMAIL && activeSortOrder === SortDirection.DESC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.EMAIL)"
                        ></span>
                    </div>
                </ng-template>

                <ng-template hamHeaderCell>
                    <div class="header-sort-col" (click)="sortBy(MfaSortingProperties.ENABLED_AT)">
                        {{'aumico_mfa_org_users_col_enabled_at' | i18next}}
                        <span
                            *ngIf="activeSortBy !== MfaSortingProperties.ENABLED_AT"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.ENABLED_AT)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.ENABLED_AT && activeSortOrder === SortDirection.ASC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.ENABLED_AT)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.ENABLED_AT && activeSortOrder === SortDirection.DESC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.ENABLED_AT)"
                        ></span>
                    </div>
                </ng-template>

                <ng-template hamHeaderCell>
                    <div class="header-sort-col" (click)="sortBy(MfaSortingProperties.STATUS)">
                        {{'aumico_mfa_org_users_col_status' | i18next}}
                        <span
                            *ngIf="activeSortBy !== MfaSortingProperties.STATUS"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.STATUS)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.STATUS && activeSortOrder === SortDirection.ASC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.STATUS)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === MfaSortingProperties.STATUS && activeSortOrder === SortDirection.DESC"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(MfaSortingProperties.STATUS)"
                        ></span>
                    </div>
                </ng-template>

                <!-- Empty header for actions column -->
                <ng-template hamHeaderCell></ng-template>

                <!-- ── Body cells ────────────────────────────────────────────── -->
                <ng-template hamCell let-user>
                    <div class="user-cell">
                        <ham-avatar
                            type="circle"
                            size="regular"
                            [fullName]="user.firstName + ' ' + user.lastName"
                        ></ham-avatar>
                        <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
                    </div>
                </ng-template>

                <ng-template hamCell let-user> {{ user.email }} </ng-template>

                <ng-template hamCell let-user>
                    {{ user.enabledAt ? formatEnabledAt(user.enabledAt) : '-' }}
                </ng-template>

                <ng-template hamCell let-user>
                    <span
                        [class]="
                            user.isMfaSetupComplete
                                ? 'status-badge status-badge--enabled'
                                : 'status-badge status-badge--not-enabled'
                        "
                    >
                        {{ (user.isMfaSetupComplete ? 'aumico_mfa_org_users_status_complete' :
                        'aumico_mfa_org_users_status_pending' ) | i18next }}
                    </span>
                </ng-template>

                <ng-template hamCell let-user>
                    <ham-button
                        *ngIf="user.isMfaSetupComplete"
                        variant="white"
                        (buttonClick)="resetUserMfa(user.userId)"
                    >
                        {{'aumico_mfa_org_users_reset_button' | i18next}}
                    </ham-button>
                </ng-template>
            </ham-table>
        </div>
    </ng-container>
</div>
